import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[mbsFiltersGroup]'
})
export class FiltersGroupDirective {
  template = inject<TemplateRef<any>>(TemplateRef);
}
